import 'client-only';

import { type Brand } from '@/consts/brands';
import { type InformationData } from '@/services/informationService/types';
import { get } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const getHealthHistoryInformation = (brand: Brand) =>
  get<{ data: InformationData[] }>(urls[brand].api.user.healthHistory);

export const InformationService = {
  getHealthHistoryInformation,
};
